import type { AttendeeCacheData } from '../schema/AttendeeCacheData';
import { getFreeBusyCacheStore } from '../store/store';

export function getAttendeeData(key: string): AttendeeCacheData | undefined {
    return getFreeBusyCacheStore().attendeeMap.get(key);
}

export function getAttendeeSessions(key: string): string[] {
    const attendeeData = getAttendeeData(key);

    return attendeeData?.sessions ?? [];
}
